import { PALETTE_KEYS, PALETTES, type Density, type PaletteKey } from "../theme/palettes";
import { SCENARIOS, currentScenario, setLatency, type Scenario } from "../data/staticSource";
import { useUiStore } from "../stores/uiStore";
import css from "./shell.module.css";

/**
 * Only rendered under /dev. Flips the appearance knobs and reseeds the static
 * store, which is how every empty state in the mockup is reachable in a browser
 * without a backend.
 */
export function DevToolbar({ onScenario }: { onScenario: (s: Scenario) => void }) {
  const palette = useUiStore((s) => s.palette);
  const setPalette = useUiStore((s) => s.setPalette);
  const density = useUiStore((s) => s.density);
  const setDensity = useUiStore((s) => s.setDensity);
  const scanlines = useUiStore((s) => s.scanlines);
  const setScanlines = useUiStore((s) => s.setScanlines);

  return (
    <div className={css.devBar}>
      <span className={css.devTag}>DEV</span>

      <label className={css.devField}>
        <span className={css.devLabel}>scenario</span>
        <select
          className={css.devSelect}
          value={currentScenario()}
          onChange={(e) => onScenario(e.currentTarget.value as Scenario)}
        >
          {SCENARIOS.map((s) => (
            <option key={s.key} value={s.key}>
              {s.label} — {s.hint}
            </option>
          ))}
        </select>
      </label>

      <label className={css.devField}>
        <span className={css.devLabel}>theme</span>
        <select
          className={css.devSelect}
          value={palette}
          onChange={(e) => setPalette(e.currentTarget.value as PaletteKey)}
        >
          {PALETTE_KEYS.map((k) => (
            <option key={k} value={k}>
              ◈ {PALETTES[k].name}
            </option>
          ))}
        </select>
      </label>

      <label className={css.devField}>
        <span className={css.devLabel}>density</span>
        <select
          className={css.devSelect}
          value={density}
          onChange={(e) => setDensity(e.currentTarget.value as Density)}
        >
          <option value="comfortable">comfortable</option>
          <option value="compact">compact</option>
        </select>
      </label>

      <label className={css.devField}>
        <span className={css.devLabel}>latency</span>
        <select
          className={css.devSelect}
          defaultValue="180"
          onChange={(e) => setLatency(Number(e.currentTarget.value))}
        >
          <option value="0">instant</option>
          <option value="180">180ms</option>
          <option value="900">900ms</option>
        </select>
      </label>

      <label className={css.devField}>
        <span className={css.devLabel}>scanlines</span>
        <input
          type="checkbox"
          checked={scanlines}
          onChange={(e) => setScanlines(e.currentTarget.checked)}
        />
      </label>

      <span className={css.devHint}>static data · no backend</span>
    </div>
  );
}
